import { Component, OnInit, Input, EventEmitter, Output,  } from '@angular/core';
import { DisplayItem } from '../../../lib/display/display-item/display-item';

@Component({
  selector: 'app-grid-visual-item-workflow',
  templateUrl: './grid-visual-item-workflow.component.html',
  styleUrls: ['./grid-visual-item-workflow.component.css']
})
export class GridVisualItemWorkflowComponent implements OnInit {
  @Input()
  displayItem: DisplayItem;

  @Output()
  onClick: EventEmitter<any> = new EventEmitter<any>();

  constructor(
  ) {

  }

  ngOnInit() {
  }

}